import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductPerPageEntityParams {
  value: number;
}
export class ProductPerPageEntity extends BaseEntityClass {
  value: number;
  constructor(params: ProductPerPageEntityParams) {
    super();
    this.type = "product-per-page";
    this.entity_version = 2;
    this.value = params.value;
  }
}
